import {GetTypes} from "../../../../helpers/enum-helpers";

export enum CompanyCreateSteps {
  GeneralInformation = 1 << 0,
  LegalInformation = 1 << 1,
  TaxInformation = 1 << 2,
  CommunicationInformation = 1 << 3,
  Shards = 1 << 4,
}

export const CompanyCreateStepsLabels: { [key: number]: string } = {
  [CompanyCreateSteps.GeneralInformation]: "Allgemeine Informationen",
  [CompanyCreateSteps.LegalInformation]: "Rechtliche Informationen",
  [CompanyCreateSteps.TaxInformation]: "Steuerinformationen",
  [CompanyCreateSteps.CommunicationInformation]: "Kommunikation",
  [CompanyCreateSteps.Shards]: "Shard-Konfiguration",
}

export const CompanyCreateStepsList: CompanyCreateSteps[] = GetTypes(CompanyCreateSteps).map(x => parseInt(x));
